import {
  Box,
  Button,
  Divider,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  Zoom,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { generateProductionDateFromBatch } from '../../../utils/generateExpirationDateFromBatch';
import { useDispatch, useSelector } from 'react-redux';
import { getUser } from '../../../redux/usersRedux';
import {
  createMicrobiology1Request,
  createSamplerRequest,
  removeMicrobiology1Request,
  removeSamplerRequest,
} from '../../../redux/microbiologyRedux';
import { loadReportPZ04ByIdRequest } from '../../../redux/reportsPZ04Redux';

const Micro_1 = ({ props }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => getUser(state));
  const { t } = useTranslation();
  const [reportNumber, setReportNumber] = useState(
    props ? props.reportNumber : '',
  );

  const [productionDate, setProductionDate] = useState(null);
  const [analyzeDate, setAnalyzeDate] = useState(dayjs(new Date()));
  const [expirityDate, setExpirityDate] = useState(
    props ? dayjs(props.expirityDate) : null,
  );
  const [other, setOther] = useState('');
  const [cultureYeast_1, setCultureYeast_1] = useState('');
  const [wildYeast_1, setWildYeast_1] = useState('');
  const [aerobicBacteria_1, setAerobicBacteria_1] = useState('');
  const [beerSpoilageBacteria_1, setBeerSpoilageBacteria_1] = useState('');
  const [other_1, setOther_1] = useState('');
  const [pcrIdentification_1, setPcrIdentification_1] = useState('');
  const [user_1, setUser_1] = useState('');
  const [userId_1, setUserId_1] = useState('');
  const [arrMicro_1, setArrMicro_1] = useState(
    props.micro_1
      ? props.micro_1.filter((micro) => micro.status === 'BEFORE')
      : [],
  );
  const [samplerPrdDate, setSamplerPrdDate] = useState(null);
  const [samplerAnalyzeDate, setSamplerAnalyzeDate] = useState(
    dayjs(new Date()),
  );
  const [samplerHL, setSamplerHL] = useState('');
  const [arrSampler, setArrSampler] = useState(
    props.micro_1_samplers ? props.micro_1_samplers : [],
  );
  const [cultureYeast_2, setCultureYeast_2] = useState('');
  const [wildYeast_2, setWildYeast_2] = useState('');
  const [aerobicBacteria_2, setAerobicBacteria_2] = useState('');
  const [beerSpoilageBacteria_2, setBeerSpoilageBacteria_2] = useState('');
  const [other_2, setOther_2] = useState('');
  const [pcrIdentification_2, setPcrIdentification_2] = useState('');
  const [user_2, setUser_2] = useState('');
  const [userId_2, setUserId_2] = useState('');
  const [arrMicro_2, setArrMicro_2] = useState(
    props.micro_1
      ? props.micro_1.filter((micro) => micro.status === 'AFTER')
      : [],
  );

  const [reloadReport, setReloadReport] = useState(0);

  useEffect(() => {
    const start = async () => {
      if (props) {
        const productionDateFromBatch = await generateProductionDateFromBatch(
          props.orderBatch,
        );
        setProductionDate(dayjs(productionDateFromBatch));
        setSamplerPrdDate(dayjs(productionDateFromBatch));
      }
    };
    start();
  }, [props]);

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadReportPZ04ByIdRequest(props.id));
      if (res) {
        setArrMicro_1(
          res.data.micro_1
            ? res.data.micro_1.filter((micro) => micro.status === 'BEFORE')
            : [],
        );
        setArrMicro_2(
          res.data.micro_1
            ? res.data.micro_1.filter((micro) => micro.status === 'AFTER')
            : [],
        );
        setArrSampler(
          res.data.micro_1_samplers ? res.data.micro_1_samplers : [],
        );
      }
    };
    start();
  }, [dispatch, props.id, reloadReport]);

  const handleMicro_1 = async (e) => {
    e.preventDefault();
    setUser_1(`${user.users.firstName} ${user.users.lastName}`);
    setUserId_1(user.users.id);
    const newMicro_1 = {
      status: 'BEFORE',
      reportPZ04Id: props.id,
      userId: user.users.id,
      cultureYeast: cultureYeast_1,
      wildYeast: wildYeast_1,
      aerobicBacteria: aerobicBacteria_1,
      beerSpoilageBacteria: beerSpoilageBacteria_1,
      other: other_1,
      pcrIdentification: pcrIdentification_1,
    };
    setArrMicro_1((prev) => [
      ...prev,
      {
        ...newMicro_1,
        user: {
          firstName: `${user.users.firstName}`,
          lastName: `${user.users.lastName}`,
        },
      },
    ]);
    setCultureYeast_1('');
    setWildYeast_1('');
    setAerobicBacteria_1('');
    setBeerSpoilageBacteria_1('');
    setOther_1('');
    setPcrIdentification_1('');
    setUser_1('');
    setUserId_1('');

    const res = await dispatch(createMicrobiology1Request(newMicro_1));
    if (res.status === 201) {
      setArrMicro_1((prev) => [
        ...prev,
        {
          ...newMicro_1,
          user: {
            firstName: `${user.users.firstName}`,
            lastName: `${user.users.lastName}`,
          },
        },
      ]);
      setReloadReport((prev) => prev + 1);
    }
    console.log('Response from creating Microbiology 1:', res);
  };

  const handleSampler = async (e) => {
    e.preventDefault();

    const newSampler = {
      reportPZ04Id: props.id,
      userId: user.users.id,
      orderNumber: props.orderNumber,
      BBT: props.BBT,
      productId: props.orderProduct.id,
      bottlingDate: dayjs(samplerPrdDate),
      analysisDate: dayjs(samplerAnalyzeDate),
      hlQty: samplerHL,
    };
    const res = await dispatch(createSamplerRequest(newSampler));
    if (res.status === 201) {
      setArrSampler((prev) => [...prev, newSampler]);
      setSamplerHL('');
      setReloadReport((prev) => prev + 1);
    }
    console.log('Sampler identification submitted', res.data);
  };

  const handleMicro_2 = async (e) => {
    e.preventDefault();
    setUser_2(`${user.users.firstName} ${user.users.lastName}`);
    setUserId_2(user.users.id);
    const newMicro_2 = {
      reportPZ04Id: props.id,
      status: 'AFTER',
      cultureYeast: cultureYeast_2,
      wildYeast: wildYeast_2,
      aerobicBacteria: aerobicBacteria_2,
      beerSpoilageBacteria: beerSpoilageBacteria_2,
      other: other_2,
      pcrIdentification: pcrIdentification_2,
      userId: user.users.id,
    };

    setCultureYeast_2('');
    setWildYeast_2('');
    setAerobicBacteria_2('');
    setBeerSpoilageBacteria_2('');
    setOther_2('');
    setPcrIdentification_2('');
    setUser_2('');
    setUserId_2('');
    const res = await dispatch(createMicrobiology1Request(newMicro_2));
    if (res.status === 201) {
      setReloadReport((prev) => prev + 1);
      setArrMicro_2((prev) => [
        ...prev,
        {
          ...newMicro_2,
          user: `${user.users.firstName} ${user.users.lastName}`,
        },
      ]);
    }
    console.log('Response from creating Microbiology 2:', res);
  };

  const handleRemove = async (arr_name, id) => {
    if (arr_name === arrMicro_1) {
      await dispatch(removeMicrobiology1Request(id));
      setArrMicro_1((prev) => prev.filter((micro) => micro.id !== id));
      setReloadReport((prev) => prev + 1);
    } else if (arr_name === arrMicro_2) {
      await dispatch(removeMicrobiology1Request(id));
      setArrMicro_2((prev) => prev.filter((micro) => micro.id !== id));
      setReloadReport((prev) => prev + 1);
    } else if (arr_name === arrSampler) {
      await dispatch(removeSamplerRequest(id));
      setArrSampler((prev) => prev.filter((sampler) => sampler.id !== id));
      setReloadReport((prev) => prev + 1);
    }
  };

  console.log(arrMicro_2);
  return (
    <Box sx={{ overflow: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_1.identificationFinishGoods')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mb: 2,
          justifyContent: 'space-between',
        }}
      >
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_1.rnNumber')}
          variant="outlined"
          value={reportNumber}
          disabled
        />
        <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            label={t('rnModule.stage_1.analyzeDate')}
            value={dayjs(analyzeDate)}
            onChange={(newValue) => {
              setAnalyzeDate(dayjs(newValue));
            }}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            label={t('rnModule.stage_1.productionDate')}
            value={dayjs(productionDate)}
            onChange={(newValue) => {
              setProductionDate(dayjs(newValue));
            }}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_1.orderNumber')}
          variant="outlined"
          value={props.orderNumber}
          disabled
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mb: 2,
          justifyContent: 'space-between',
        }}
      >
        <TextField
          sx={{ width: '15%', mr: 2 }}
          label={t('rnModule.stage_1.materialNumber')}
          variant="outlined"
          value={props.orderProduct.materialNumber}
          disabled
        />
        <TextField
          sx={{ width: '45%', mr: 2 }}
          label={t('rnModule.stage_1.brand')}
          variant="outlined"
          value={props.orderProduct.description}
          disabled
        />
        <TextField
          sx={{ width: '15%', mr: 2 }}
          label={t('rnModule.stage_1.package')}
          variant="outlined"
          value={props.orderProduct.package.description}
          disabled
        />
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_1.packagingCode')}
          variant="outlined"
          value={`${dayjs(props.expirityDate).format('DD.MM.YYYY')} ${
            props.orderBatch
          }`}
          disabled
        />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          mb: 2,
          justifyContent: 'space-between',
        }}
      >
        <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
          <DatePicker
            format="DD.MM.YYYY"
            views={['year', 'month', 'day']}
            label={t('rnModule.stage_1.expirityDate')}
            value={dayjs(expirityDate)}
            onChange={(newValue) => {
              setExpirityDate(dayjs(newValue));
            }}
            slotProps={{
              textField: {
                error: false,
              },
            }}
            sx={{ mr: 2 }}
            renderInput={(params) => <TextField {...params} />}
          />
        </LocalizationProvider>
        <TextField
          sx={{ width: '15%', mr: 2 }}
          label={t('rnModule.stage_1.BBTnumber')}
          variant="outlined"
          value={props.BBT}
          disabled
        />
        <TextField
          sx={{ width: '45%', mr: 2 }}
          label={t('rnModule.stage_1.other')}
          variant="outlined"
          value={other}
          onChange={(e) => setOther(e.target.value)}
        />
        <TextField
          sx={{ width: '25%', mr: 2 }}
          label={t('rnModule.stage_1.details')}
          variant="outlined"
          value={other}
          onChange={(e) => setOther(e.target.value)}
        />
      </Box>

      {/* Wynik analizy mikrobiologicznej  */}

      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_1.resultsOfAnalysis')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />

      <Box component={'form'} onSubmit={handleMicro_1} sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            mb: 2,
            justifyContent: 'space-between',
          }}
        >
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.cultureYeast')}
            variant="outlined"
            value={cultureYeast_1}
            onChange={(e) => setCultureYeast_1(e.target.value)}
          />
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.wildYeast')}
            variant="outlined"
            value={wildYeast_1}
            onChange={(e) => setWildYeast_1(e.target.value)}
          />
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.aerobicBacteria')}
            variant="outlined"
            value={aerobicBacteria_1}
            onChange={(e) => setAerobicBacteria_1(e.target.value)}
          />
          <Tooltip
            title={
              <Typography sx={{ fontSize: '15px' }}>
                {t('rnModule.stage_1.nbbTooltip')}
              </Typography>
            }
            placement="top"
            slots={{ transition: Zoom }}
          >
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={t('rnModule.stage_1.beerSpoilageBacteria')}
              variant="outlined"
              value={beerSpoilageBacteria_1}
              onChange={(e) => setBeerSpoilageBacteria_1(e.target.value)}
            />
          </Tooltip>
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.other')}
            variant="outlined"
            value={other_1}
            onChange={(e) => setOther_1(e.target.value)}
          />
          <Tooltip
            title={<Typography>{t('rnModule.stage_1.pcrTooltip')}</Typography>}
            placement="top"
            slots={{ transition: Zoom }}
          >
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={t('rnModule.stage_1.pcrIdentifiaction')}
              variant="outlined"
              value={pcrIdentification_1}
              onChange={(e) => setPcrIdentification_1(e.target.value)}
            />
          </Tooltip>
        </Box>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={
            !cultureYeast_1 &&
            !wildYeast_1 &&
            !aerobicBacteria_1 &&
            !beerSpoilageBacteria_1 &&
            !other_1 &&
            !pcrIdentification_1
          }
          sx={{ mb: 2 }}
        >
          {t('rnModule.stage_1.submitMicro_1')}
        </Button>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t('rnModule.stage_1.cultureYeast')}</TableCell>
                <TableCell>{t('rnModule.stage_1.wildYeast')}</TableCell>
                <TableCell>{t('rnModule.stage_1.aerobicBacteria')}</TableCell>
                <TableCell>
                  {t('rnModule.stage_1.beerSpoilageBacteria')}
                </TableCell>
                <TableCell>{t('rnModule.stage_1.other_micro_1')}</TableCell>
                <TableCell>{t('rnModule.stage_1.pcrIdentifiaction')}</TableCell>
                <TableCell>{t('rnModule.stage_1.micro_1user')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arrMicro_1.map((micro) => (
                <TableRow
                  hover
                  key={micro.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>
                    <Button
                      sx={{ color: 'red', p: '0' }}
                      onClick={() => handleRemove(arrMicro_1, micro.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                  <TableCell>{micro.cultureYeast}</TableCell>
                  <TableCell>{micro.wildYeast}</TableCell>
                  <TableCell>{micro.aerobicBacteria}</TableCell>
                  <TableCell>{micro.beerSpoilageBacteria}</TableCell>
                  <TableCell>{micro.other}</TableCell>
                  <TableCell>{micro.pcrIdentification}</TableCell>
                  <TableCell>{`${micro.user.firstName} ${micro.user.lastName}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Divider sx={{ width: '100%', mt: 2, mb: 2, bgcolor: '#C09A53' }} />

      {/* Koniec analizy mikrobiologicznej */}

      {/* Identyfikacja samplera "Po pasteryzacji"  */}

      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_1.samplerIdentification')}
      </Typography>
      <Divider sx={{ width: '100%', mt: 2, bgcolor: '#C09A53' }} />

      <Box component={'form'} onSubmit={handleSampler} sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            mt: 2,
            mb: 2,
            justifyContent: 'space-between',
          }}
        >
          <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{ width: '20%', mr: 2 }}
              format="DD.MM.YYYY"
              views={['year', 'month', 'day']}
              label={t('rnModule.stage_1.productionDate')}
              value={dayjs(samplerPrdDate)}
              onChange={(newValue) => {
                setSamplerPrdDate(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <TextField
            sx={{ width: '15%', mr: 2 }}
            label={t('rnModule.stage_1.orderNumber')}
            variant="outlined"
            value={props.orderNumber}
            disabled
          />
          <TextField
            sx={{ width: '12%', mr: 2 }}
            label={t('rnModule.stage_1.BBTnumber')}
            variant="outlined"
            value={props.BBT}
            disabled
          />
          <LocalizationProvider adapterLocale="pl" dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{ width: '20%', mr: 2 }}
              format="DD.MM.YYYY"
              views={['year', 'month', 'day']}
              label={t('rnModule.stage_1.analyzeDate')}
              value={dayjs(samplerAnalyzeDate)}
              onChange={(newValue) => {
                setSamplerAnalyzeDate(dayjs(newValue));
              }}
              slotProps={{
                textField: {
                  error: false,
                },
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
          <TextField
            sx={{ width: '45%', mr: 2 }}
            label={t('rnModule.stage_1.brand')}
            variant="outlined"
            value={props.orderProduct.description}
            disabled
          />
          <TextField
            sx={{ width: '15%', mr: 2 }}
            label={t('rnModule.stage_1.materialNumber')}
            variant="outlined"
            value={props.orderProduct.materialNumber}
            disabled
          />
          <TextField
            sx={{ width: '15%', mr: 2 }}
            label={t('rnModule.stage_1.qtyHL')}
            variant="outlined"
            value={samplerHL}
            onChange={(e) => setSamplerHL(e.target.value)}
          />
          <TextField
            sx={{ width: '15%', mr: 2 }}
            label={t('rnModule.stage_1.package')}
            variant="outlined"
            value={props.orderProduct.package.description}
            disabled
          />
        </Box>
        <Button type="submit" variant="contained" color="primary">
          {t('rnModule.stage_1.submitSampler')}
        </Button>
        <Divider sx={{ width: '100%', mt: 2, mb: 2, bgcolor: '#C09A53' }} />

        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t('rnModule.stage_1.rnNumber')}</TableCell>
                <TableCell>{t('rnModule.stage_1.productionDate')}</TableCell>
                <TableCell>{t('rnModule.stage_1.orderNumber')}</TableCell>
                <TableCell>{t('rnModule.stage_1.BBTnumber')}</TableCell>
                <TableCell>{t('rnModule.stage_1.analyzeDate')}</TableCell>
                <TableCell>{t('rnModule.stage_1.brand')}</TableCell>
                <TableCell>{t('rnModule.stage_1.materialNumber')}</TableCell>
                <TableCell>{t('rnModule.stage_1.qtyHL')}</TableCell>
                <TableCell>{t('rnModule.stage_1.package')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arrSampler.map((sampler) => (
                <TableRow
                  hover
                  key={sampler.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>
                    <Button
                      sx={{ color: 'red', p: '0' }}
                      onClick={() => handleRemove(arrSampler, sampler.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                  <TableCell>{props.reportNumber}</TableCell>
                  <TableCell>
                    {dayjs(sampler.bottlingDate).format('DD.MM.YYYY')}
                  </TableCell>
                  <TableCell>{props.orderNumber}</TableCell>
                  <TableCell>{props.BBT}</TableCell>
                  <TableCell>
                    {dayjs(sampler.analysisDate).format('DD.MM.YYYY')}
                  </TableCell>
                  <TableCell>{props.orderProduct.description}</TableCell>
                  <TableCell>{props.orderProduct.materialNumber}</TableCell>
                  <TableCell>{sampler.hlQty}</TableCell>
                  <TableCell>
                    {props.orderProduct.package.description}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {/* Koniec identyfikacji samplera "Po pasteryzacji" */}

      {/* Wynik analizy mikrobiologicznej samplera "Po pasteryzacji" */}

      <Typography
        variant="h6"
        component="h2"
        gutterBottom
        fontWeight="bold"
        fontStyle="italic"
      >
        {t('rnModule.stage_1.resultsOfAnalysisSampler')}
      </Typography>
      <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
      <Box component={'form'} onSubmit={handleMicro_2} sx={{ mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            mb: 2,
            justifyContent: 'space-between',
          }}
        >
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.cultureYeast')}
            variant="outlined"
            value={cultureYeast_2}
            onChange={(e) => setCultureYeast_2(e.target.value)}
          />
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.wildYeast')}
            variant="outlined"
            value={wildYeast_2}
            onChange={(e) => setWildYeast_2(e.target.value)}
          />
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.aerobicBacteria')}
            variant="outlined"
            value={aerobicBacteria_2}
            onChange={(e) => setAerobicBacteria_2(e.target.value)}
          />
          <Tooltip
            title={t('rnModule.stage_1.nbbTooltip')}
            placement="top"
            slots={{ transition: Zoom }}
          >
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={t('rnModule.stage_1.beerSpoilageBacteria')}
              variant="outlined"
              value={beerSpoilageBacteria_2}
              onChange={(e) => setBeerSpoilageBacteria_2(e.target.value)}
            />
          </Tooltip>
          <TextField
            sx={{ width: '25%', mr: 2 }}
            label={t('rnModule.stage_1.other')}
            variant="outlined"
            value={other_2}
            onChange={(e) => setOther_2(e.target.value)}
          />
          <Tooltip
            title={t('rnModule.stage_1.pcrTooltip')}
            placement="top"
            slots={{ transition: Zoom }}
          >
            <TextField
              sx={{ width: '25%', mr: 2 }}
              label={t('rnModule.stage_1.pcrIdentifiaction')}
              variant="outlined"
              value={pcrIdentification_2}
              onChange={(e) => setPcrIdentification_2(e.target.value)}
            />
          </Tooltip>
        </Box>
        <Button
          type="submit"
          variant="contained"
          color="primary"
          disabled={
            !cultureYeast_2 &&
            !wildYeast_2 &&
            !aerobicBacteria_2 &&
            !beerSpoilageBacteria_2 &&
            !other_2 &&
            !pcrIdentification_2
          }
          sx={{ mb: 2 }}
        >
          {t('rnModule.stage_1.submitMicro_1')}
        </Button>
        <Divider sx={{ width: '100%', mb: 2, bgcolor: '#C09A53' }} />
        <TableContainer component={Paper} sx={{ mb: 2 }}>
          <Table sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell></TableCell>
                <TableCell>{t('rnModule.stage_1.cultureYeast')}</TableCell>
                <TableCell>{t('rnModule.stage_1.wildYeast')}</TableCell>
                <TableCell>{t('rnModule.stage_1.aerobicBacteria')}</TableCell>
                <TableCell>
                  {t('rnModule.stage_1.beerSpoilageBacteria')}
                </TableCell>
                <TableCell>{t('rnModule.stage_1.other_micro_1')}</TableCell>
                <TableCell>{t('rnModule.stage_1.pcrIdentifiaction')}</TableCell>
                <TableCell>{t('rnModule.stage_1.micro_1user')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {arrMicro_2.map((micro) => (
                <TableRow
                  hover
                  key={micro.id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>
                    <Button
                      sx={{ color: 'red', p: '0' }}
                      onClick={() => handleRemove(arrMicro_2, micro.id)}
                    >
                      <DeleteIcon />
                    </Button>
                  </TableCell>
                  <TableCell>{micro.cultureYeast}</TableCell>
                  <TableCell>{micro.wildYeast}</TableCell>
                  <TableCell>{micro.aerobicBacteria}</TableCell>
                  <TableCell>{micro.beerSpoilageBacteria}</TableCell>
                  <TableCell>{micro.other}</TableCell>
                  <TableCell>{micro.pcrIdentification}</TableCell>
                  <TableCell>{`${micro.user.firstName} ${micro.user.lastName}`}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Divider sx={{ width: '100%', mt: 2, mb: 2, bgcolor: '#C09A53' }} />
      {/* Koniec analizy mikrobiologicznej samplera "Po pasteryzacji" */}
      <Button
        onClick={() => {
          console.log('Final report data:');
        }}
        sx={{
          color: 'white',
          bgcolor: '#C09A53',
          ':hover': { bgcolor: '#9c7c43' },
          height: '40px',
          width: '150px',
          mt: 2,
          mb: 50,
        }}
      >
        {t('rnModule.stage_1.confirmationFirstStep')}
      </Button>
    </Box>
  );
};

export default Micro_1;
